import React, { Component } from 'react';
import { connect } from 'react-redux';

import { HIDE_HEADER } from '../../constants/index.js';

import { showBanner } from '../../services/banner/actions';

import NavComponent from './NavComponent';
import HeaderComponent from './HeaderComponent';

import { HeaderNav } from './HeaderNavComponentStyle.js';

class HeaderNavComponent extends Component {
    render() {
        return (
            <HeaderNav id="entete" className={`entete ${HIDE_HEADER ? 'no-header' : ''}`}>
                {!HIDE_HEADER && (
                    <div className="flex-container-v">
                        <HeaderComponent />
                        <NavComponent />
                    </div>
                )}
            </HeaderNav>
        );
    }
}

const mapDispatchToProps = {
    showBanner
};

export default connect(null, mapDispatchToProps)(HeaderNavComponent);



// WEBPACK FOOTER //
// ./src/components/header/HeaderNavComponent.js